import { translate } from "../Services/translation";
import { MobileBreakpoint } from "../constants";

/* List that keeps track of if video-element has been initialized */
let initializedVideos = new WeakSet();

export function initializeInlineVideoControls(video) {
	if (initializedVideos.has(video)) return;
	initializedVideos.add(video);

	const { src, mobileSrc, type, mobileType, poster, mobilePoster } = video.dataset;
	const mediaQuery = window.matchMedia(`(max-width: ${MobileBreakpoint}px)`);
	const buttonWrapper = video.nextElementSibling;
	const button = buttonWrapper?.querySelector("button");
	const source = video.querySelector('source') || video;
	const progressCircle = buttonWrapper?.querySelector("circle");

	setVideoSource();
	mediaQuery.addEventListener('change', setVideoSource);
	button?.addEventListener("click", () => video.paused ? playVideo() : pauseVideo());

	if (progressCircle) {
		const radius = progressCircle.r.baseVal.value;
		const circumference = 2 * Math.PI * radius;
		progressCircle.style.strokeDasharray = `${circumference}`;
		progressCircle.style.strokeDashoffset = `0`;

		function setRemainingTime(percent) {
			const offset = (percent / 100) * circumference * -1;
			percent < 2 || percent >= 99
				? progressCircle.style.transition = 'none'
				: progressCircle.style.removeProperty('transition');
			progressCircle.style.strokeDashoffset = offset;
		}

		video.addEventListener("loadedmetadata", function () {
			const videoDuration = video.duration;

			video.addEventListener("timeupdate", function () {
				const currentTime = video.currentTime;
				const percent = Math.round((currentTime / videoDuration) * 100);
				setRemainingTime(percent);
			});
		});
	}

	function setVideoSource() {
		pauseVideo();
		if (mediaQuery.matches) {
			source.src = mobileSrc || src;
			source.type = mobileType || type;
			video.poster = mobilePoster || poster;
		} else {
			source.src = src || mobileSrc;
			source.type = type || mobileType;
			video.poster = poster || mobilePoster;
		}
		video.load();
	}

	function pauseVideo() {
		video.pause();
		video.dataset.paused = true;
		button.dataset.paused = true;
		button.dataset.title = translate("video.play");
		button.ariaLabel = translate("video.play");
	}

	function playVideo() {
		video.play();
		video.dataset.paused = false;
		button.dataset.paused = false;
		button.dataset.title = translate("video.pause");
		button.ariaLabel = translate("video.pause");
	}
}
